import { React, useEffect } from "react";
import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import menuLogo from "../assets/imagens/pentalobe.png";
import { useDispatch, useSelector } from "react-redux";
import { checkAuth } from '../redux/reducers/userSlice'; // Importa o thunk
import { useLocation } from 'react-router-dom';

const MenuPrincipal = () => {
    const dispatch = useDispatch();
    const { user} = useSelector((state) => state.user)
    const location = useLocation();
    const navbarClass = location.pathname === "/" ? "fundo-nav" : "fundo-nav-2";
    const isHomeRoute = location.pathname === "/";
    const isActive = (path) => location.pathname === path ? 'active' : ''
    
    useEffect(() => {
        if (!user) {
            dispatch(checkAuth());
        }
    }, [user, dispatch]);
    return (
        <div>
            <Navbar expand="lg" className={navbarClass}>
                <div className="header-container">
                    <a href="/"><img className="logo-menu" src={menuLogo} alt="fundo-imagem-home" /></a>
                    {/*<div className="cart-container d-lg-none">
                    <Nav.Link href="/carrinho">
                        <i className="fa-solid fa-shopping-cart cart-icon"></i>
                        {products.length > 0 && (
                            <Badge pill className="cart-count">
                                {products.length}
                            </Badge>
                        )}
                    </Nav.Link>
                </div>*/}
                </div>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav ">
                    <Nav className="nav-item config-celular">
                        <Nav.Link href="/"><Button className={`botao-geral-menu config-celular-botao ${isActive('/')}`}>Home</Button></Nav.Link>
                        <Nav.Link href="/quero-vender"><Button className={`botao-geral-menu config-celular-botao ${isActive('/quero-vender')}`}>Quero Vender</Button></Nav.Link>
                        <Nav.Link href="/quero-comprar"><Button className={`botao-geral-menu config-celular-botao ${isActive('/quero-comprar')}`}>Quero Comprar</Button></Nav.Link>
                        {/*<Nav.Link href="/quero-comprar"><Button className="botao-geral-menu config-celular-botao">Quero Comprar</Button></Nav.Link>*/}
                        <Nav.Link href="/blog"><Button className={`botao-geral-menu config-celular-botao ${isActive('/blog')}`}>Blog</Button></Nav.Link>
                        <Nav.Link href="/login"><Button className="botao-geral-menu config-celular-botao">Login</Button></Nav.Link>
                    </Nav>

                </Navbar.Collapse>
                {!isHomeRoute && ( 
                <div className="footer-container">
                   {/* <div className="cart-container d-none d-md-block">
                        <Nav.Link href="/carrinho">
                            <i className="fa-solid fa-shopping-cart cart-icon"></i>
                            {products.length > 0 && (
                                <Badge pill className="cart-count">
                                    {products.length}
                                </Badge>
                            )}
                        </Nav.Link>
                    </div>*/}
                    {user !== undefined && (
                        <div className="user-greeting-container d-none d-md-block">
                            <span className="user-greeting">
                               <a  target="_blanck" style={{textDecoration:'none', color:'#FFFF'}} href="/dashboard"> {user ? `Olá, ${user?.name?.split(" ")[0]}!` : "Olá, visitante!"}</a>
                            </span>
                        </div>
                    )}
                </div>
                )}
            </Navbar>

        </div>
    );
};

export default MenuPrincipal;